import { Navigate, Outlet, createBrowserRouter } from "react-router";
import { useSession } from "./lib/api";
import { Layout } from "./layout";
import AuditPage from "./pages/audit";
import BroadcastsPage from "./pages/broadcasts";
import CatalogPage from "./pages/catalog";
import CompaniesPage from "./pages/companies";
import CompanyPage from "./pages/company";
import DashboardPage from "./pages/dashboard";
import InvoicesPage from "./pages/invoices";
import LeadsPage from "./pages/leads";
import LoginPage from "./pages/login";
import MenuPacksPage from "./pages/menu-packs";
import MoneyPage from "./pages/money";
import NotificationsPage from "./pages/notifications";
import { ForgotPasswordPage, ResetPasswordPage } from "./pages/password";
import SalesPage from "./pages/sales";
import SchedulePage from "./pages/schedule";
import SettingsPage from "./pages/settings";
import StaffPage from "./pages/staff";
import StaffFinancePage from "./pages/staff-finance";
import SupportPage from "./pages/support";

function RequireAuth() {
  const s = useSession();
  return s ? <Layout><Outlet /></Layout> : <Navigate to="/login" replace />;
}

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/reset-password", element: <ResetPasswordPage /> },
  {
    path: "/",
    element: <RequireAuth />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: "companies", element: <CompaniesPage /> },
      { path: "companies/:id", element: <CompanyPage /> },
      { path: "support", element: <SupportPage /> },
      { path: "leads", element: <LeadsPage /> },
      { path: "notifications", element: <NotificationsPage /> },
      { path: "broadcasts", element: <BroadcastsPage /> },
      // Центр обучения — отдельный чанк: уроки (ru/ky) не грузятся вместе с админкой
      { path: "learn", lazy: async () => ({ Component: (await import("./pages/learn")).LearnHome }) },
      { path: "learn/:id", lazy: async () => ({ Component: (await import("./pages/learn")).LearnLesson }) },
      { path: "invoices", element: <InvoicesPage /> },
      { path: "sales", element: <SalesPage /> },
      { path: "schedule", element: <SchedulePage /> },
      { path: "money", element: <MoneyPage /> },
      { path: "staff-finance", element: <StaffFinancePage /> },
      { path: "catalog", element: <CatalogPage /> },
      { path: "menu-packs", element: <MenuPacksPage /> },
      { path: "staff", element: <StaffPage /> },
      { path: "settings", element: <SettingsPage /> },
      { path: "audit", element: <AuditPage /> },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);
